import teamSetupPickerStore from "../store/store";
import { mutatorAction } from "satcheljs";
import { TeamSetupPickerStepState, TeamSetupMode } from "../store/schema/TeamSetupPickerStore";
import { trace } from "owa-trace";

/**
 * Updates the current step in the team setup flow to the next state.
 * Dynamically determines the next step based on the setup mode (create or restore).
 */

export default mutatorAction('GOTO_NEXT_SETUP_STEP', function gotoNextSetupStep() {
    if ((teamSetupPickerStore.currentSetupStepIndex >= 0) &&
        teamSetupPickerStore.setupSequence &&
        (teamSetupPickerStore.currentSetupStepIndex < teamSetupPickerStore.setupSequence.length - 1)) {

            const currentStep = teamSetupPickerStore.setupSequence[teamSetupPickerStore.currentSetupStepIndex];

            // Check if we're on MSTeamPicker step and need to update the sequence based on setup mode
            if (currentStep === TeamSetupPickerStepState.MSTeamPicker) {
                const setupMode = teamSetupPickerStore.teamSetupInfo?.setupMode;
                const isRestoreMode = setupMode === TeamSetupMode.RestoreOriginalSchedule;

                const nextStepIndex = teamSetupPickerStore.currentSetupStepIndex + 1;
                const currentNextStep = teamSetupPickerStore.setupSequence[nextStepIndex];

                // Only modify if the current next step is TimeZonePicker or RestoreSchedule
                if (currentNextStep === TeamSetupPickerStepState.TimeZonePicker ||
                    currentNextStep === TeamSetupPickerStepState.RestoreSchedule) {
                    teamSetupPickerStore.setupSequence[nextStepIndex] = isRestoreMode
                        ? TeamSetupPickerStepState.RestoreSchedule
                        : TeamSetupPickerStepState.TimeZonePicker;
                }
            }

            teamSetupPickerStore.currentSetupStepIndex++;
    } else {
        trace.warn("Team setup: error with gotoNextSetupStep occurred");
    }
});
